<template>
 <div>
   <div class="btn-wrapper">
     <btn type="normal" size="normal" :label="lang[2]" @click="deleteModal=true"></btn>
      <router-link :to="{ name: 'request.edit', params: {id: $route.params.id } }">
       <btn type="primary" size="normal" :label="lang[5]"></btn>
     </router-link>
   </div>
   <modal v-if="deleteModal" @close="close">
     <p class="text-center detail-title">{{lang[0]}}</p>
     <p class="text-center detail-text">{{lang[1]}}</p>
     <div class="decide-button-wrpper">
       <btn type="text-center cancel" size="normal" :label="lang[3]" @click="deleteModal=false"></btn>
       <btn type="text-center primary" size="normal" :label="lang[4]" @click="deleteIdea(id)"></btn>
     </div>
   </modal>
 </div>
</template>

<script>
import axios from 'axios'
import Btn from '../components/Button.vue'
import Modal from '../components/Modal.vue'
import RequestDeleteLangMaster from '../masters/langMaster/RequestDeleteLangMaster'

export default {
  name: 'DeleteRequst',

  components:{
    axios,
    Btn,
    Modal
  },

  props:[
    'id',
  ],

  data(){
    return{
      deleteModal: false,
      lang: RequestDeleteLangMaster[this.$store.state.account.lang],
    }
  },


  methods:{
    close(){
      this.deleteModal = false
    },


    deleteIdea(id){
      axios.delete(`private/request/delete/${this.id}`)
      .then((data) => {
        this.$parent.$parent.noticeType = 'success'
        this.$parent.$parent.noticeTitle = 'success!'
        this.$parent.$parent.noticeText = 'Your request was deleted!'
        this.$parent.$parent.isNotice = true
        this.$router.push(`/home`)
      }).catch((err) => {
        console.log(err);
      });
    }
  }
}


</script>

<style>
.decide-button-wrpper{
  justify-content: space-around;
  display: flex;
  margin-top: 20px;
}

.btn-wrapper {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.detail-text{
  font-size: 12px;
}

@media screen and (min-width: 800px){
  .detail-title {
    font-size: 18px;
  }

  .detail-text {
    font-size: 16px;
  }
}
</style>
